import styled from "styled-components"

const EventsItem = styled.div`
  border-bottom: 1px solid ${(props) => props.theme.a_color_gradients.a_light};
  &:hover div:first-of-type::before {
    background-color: ${(props) => props.theme.b_color_gradients.b_dark};
  }
`

export { EventsItem }
